var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", { staticClass: "k-switch", class: _vm.classes }, [
    _c("div", { style: _vm.isActive ? _vm.$coreOutline : {} }, [
      _c("div", { staticClass: "k-switch-input-wrapper" }, [
        _c("input", {
          ref: "input",
          staticClass: "k-switch-input",
          attrs: {
            type: "checkbox",
            dir: "auto",
            disabled: _vm.disabled,
            name: _vm.name,
            tabindex: _vm.tabindex,
          },
          domProps: { checked: _vm.isChecked, value: _vm.submittedValue },
          on: { blur: _vm.onBlur, click: _vm.onClick, focus: _vm.onFocus },
        }),
        _c("div", { staticClass: "k-switch-thumb" }),
        _c("div", { staticClass: "k-switch-track" }),
      ]),
    ]),
    _vm.label || _vm.$slots.default
      ? _c(
          "div",
          { staticClass: "k-switch-label-text" },
          [
            _vm._t("default", function () {
              return [_vm._v(_vm._s(_vm.label))]
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }